module.exports = __webpack_public_path__ + "img/Info Page 1 Top.75f010d1.png";